// src/components/ui/SinAccesoModulo.js
//
// Lo que ve quien abre por la dirección (o por un enlace) un módulo que no tiene en Permisos. Lo muestra el candado
// de ruta de Layout.js (pages/accesoModulos.js) EN LUGAR del módulo, que no se monta. A propósito no dice qué módulo
// es: nombrarlo sería contarle a la persona qué hay en esa dirección (pedido de Toto, 09/10/2026).
// Mismo dibujo que el "Acceso restringido" de Costos IA y Lumi.
import React from 'react';
import { LockClosedIcon, HomeIcon } from './Icons';

const ESTILOS = `
@media (max-width: 768px) {
  .sin-acceso-root { padding: 12px 5px 0 5px !important; }
}
`;

export default function SinAccesoModulo({ onIrAInicio }) {
  return (
    <div className="module-content">
      <div className="sin-acceso-root" style={{ padding: '20px' }}>
        <style>{ESTILOS}</style>
        <div className="card slide-in-up fade-in" style={{ textAlign: 'center', padding: '60px 20px' }}>
          <div style={{ display: 'inline-flex', color: 'var(--color-peligro)', marginBottom: '12px' }}>
            <LockClosedIcon className="w-16 h-16" />
          </div>
          <h3 style={{ color: 'var(--color-texto)', margin: '0 0 8px 0', fontSize: '18px' }}>
            No tenés acceso a este módulo
          </h3>
          <p style={{
            color: 'var(--color-texto-secundario)', margin: '0 auto 20px', fontSize: '14px',
            lineHeight: 1.6, maxWidth: '440px'
          }}>
            No está en tus permisos. Si lo necesitás, pedíselo a un administrador; si te lo acaban de asignar,
            actualizá la página.
          </p>
          <button
            type="button"
            className="btn-press hover-bright btn-movil-full"
            onClick={onIrAInicio}
            style={{
              height: '38px', padding: '0 20px', boxSizing: 'border-box',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
              background: 'var(--color-primario)', color: 'white', border: 'none',
              borderRadius: 'var(--radio-sm, 6px)', cursor: 'pointer', fontSize: '14px', fontWeight: 600
            }}
          >
            <HomeIcon className="w-4 h-4" /> Ir a Inicio
          </button>
        </div>
      </div>
    </div>
  );
}
